/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Users_Price_YearlyInputs */



/**
* | output |
* | --- |
* | "$100/year" |
*
* @param {Team_Manager_Add_Users_Price_YearlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_users_price_yearly = /** @type {((inputs?: Team_Manager_Add_Users_Price_YearlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Users_Price_YearlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("100 $/an")
	if (locale === "de") return /** @type {LocalizedString} */ ("100 $/Jahr")
	if (locale === "it") return /** @type {LocalizedString} */ ("100 $/anno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("$100/год")
	if (locale === "es") return /** @type {LocalizedString} */ ("100 $/año")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每年 100 美元")
	if (locale === "ja") return /** @type {LocalizedString} */ ("年額 $100")
	if (locale === "hi") return /** @type {LocalizedString} */ ("$100/वर्ष")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("100 $/ano")
	return /** @type {LocalizedString} */ ("$100/year")
});